<template>
  <div class="timeline-section d-flex justify-center align-center">
    <div class="timeline-wrapper py-5">
      <div class="text-center mb-5 timeline-title">
        <h1>Timeline PPDB</h1>
        <!-- <h1>Gelombang {{ wave }}</h1> -->
        <h1>2024/2025</h1>
      </div>

      <v-timeline align-top>
        <v-timeline-item v-for="(item, index) in timelines" :key="item.color" :color="item.color">
          <div class="pb-16" :class="index % 2 == 1 ? 'even-timeline-text' : ''">
            <h4
              :class="
                `font-weight-light mb-4 ${item.color}--text timeline-date`
              "
            >{{ item.date }}</h4>
            <h3 class="font-weight-light timeline-text">{{ item.text }}</h3>
          </div>
        </v-timeline-item>
      </v-timeline>

      <!-- <v-alert class="mt-5" type="warning">
        Pelaksanaan seleksi PPDB SMK Raden Umar Said gelombang 2, yang semula tanggal 2 Mei 2020
        <strong>ditunda</strong> sampai ada informasi lebih lanjut
      </v-alert> -->
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "TimelineSection",
  props: ["currentWave"],
  data: () => ({
    timelines: [
      {
        date: "",
        text: "Pendaftaran dibuka",
        color: "green"
      },
      { date: "", text: "Tes seleksi masuk", color: "pink" },
      {
        date: "",
        text: "Pengumuman hasil seleksi",
        color: "orange"
      },
      {
        date: "",
        text: "Daftar ulang",
        color: "blue"
      }
    ],
    wave: "",

    // tiap gelombang beda-beda (di gelombang yang on-site service dinonaktifkan, biasanya gel 4)
    daftarUlang: "16 Januari 2024 - 22 Januari 2024",

    // disable close test in Gel 3
    closeTest: "17 Mei 2023"
  }),
  methods: {
    checkWave() {
      if (this.wave == 3 || this.wave == 4) return true;
      else return false;
    }
  },
  mounted() {
    moment.locale("id");

    // disable dynamic timeline in Gel 4

    this.wave = this.currentWave[0].wave;
    this.timelines[0].date = `${moment(this.currentWave[0].open).format(
      "LL"
    )} - ${moment(this.currentWave[0].close).format("LL")}`;
  
    this.timelines[1].date = moment(this.currentWave[0].test).format("LL");

    // disable close test in Gel 3
    this.timelines[1].date = `${moment(this.currentWave[0].test).format("LL")}`;

    this.timelines[2].date = moment(this.currentWave[0].result).format("LL");
    this.timelines[3].date = this.daftarUlang;
    
    // daftar ulang and pengumuman hasil seleksi in Gel 4 2022/2023
    // this.timelines[0].date = "1 Juli 2022 - 5 Juli 2022"
    // this.timelines[1].date = "1 Juli 2022 - 5 Juli 2022"
    // this.timelines[2].date = "1 Juli 2022 - 5 Juli 2022"
    // this.timelines[3].date = "1 Juli 2022 - 5 Juli 2022"

    // this.timelines[1].date = "Ditunda";
    // this.timelines[2].date = "Ditunda";
  }
};
</script>

<style scoped>
.timeline-section {
  margin: 100px 0 0 0;
}

.timeline-wrapper {
  width: 800px;
}

@media screen and (max-width: 950px) {
  .timeline-wrapper {
    width: 90%;
  }
}
</style>

<style>
.even-timeline-text {
  text-align: end!important;
}
</style>
